import { AxiosResponse } from 'axios';
import { NextApiRequestQuery } from 'next/dist/server/api-utils';
import {
    AccountDocumentApiInterface,
    AccountSubsidyListApiInterface,
    CreateTransactionListApiInterface,
    ExportApiType,
    ResponseApiSimple,
    TransactionApiInterface,
    TransactionListApiInterface,
    TransactionsTemplatesApiInterface,
} from 'submodules/api_middleware';
import { QueryRequestInterface } from 'submodules/api_middleware/src/interfaces/InternalInterfaces';
import fetcher, { MethodEnum } from 'utils/helpers/browser/newFetcher';

export const getTransaction = async (
    transactionId: number
): Promise<AxiosResponse<TransactionApiInterface>> => {
    return await fetcher(`/api/account/transaction/detail`, MethodEnum.GET, {
        transactionId,
    });
};

export const getSubsidiesDocuments = async (
    query: NextApiRequestQuery
): Promise<AxiosResponse<AccountSubsidyListApiInterface[]>> => {
    return await fetcher(
        `/api/account/document/subsidy/list`,
        MethodEnum.GET,
        query
    );
};

export const getDocuments = async (
    query: NextApiRequestQuery
): Promise<AxiosResponse<AccountDocumentApiInterface[]>> => {
    return await fetcher(`/api/account/document/list`, MethodEnum.GET, query);
};

export const createDocuments = async (): Promise<ResponseApiSimple> => {
    return await fetcher(`/api/account/document/create`, MethodEnum.POST);
};

export const markAsFinalDocument = async (
    documentId: number
): Promise<ResponseApiSimple> => {
    return await fetcher(
        `/api/account/document/mark-final`,
        MethodEnum.POST,
        null,
        {
            documentId,
        }
    );
};

export const listAccountTransactions = async (
    query: QueryRequestInterface
): Promise<AxiosResponse<TransactionListApiInterface[] | ExportApiType>> => {
    return await fetcher(`/api/account/transactions`, MethodEnum.GET, query);
};

export const listDocumentTransactions = async (
    documentId: number,
    query: QueryRequestInterface
): Promise<AxiosResponse<TransactionListApiInterface[] | ExportApiType>> => {
    return await fetcher(
        `/api/account/document/${documentId}/transactions`,
        MethodEnum.GET,
        query
    );
};

export const cancelTransaction = async (
    transactionId: number
): Promise<ResponseApiSimple> => {
    return await fetcher(
        `/api/account/transaction/cancel`,
        MethodEnum.POST,
        null,
        { transactionId }
    );
};

export const createTransaction = async (
    data: CreateTransactionListApiInterface
): Promise<ResponseApiSimple> => {
    return await fetcher(
        `/api/account/transaction/create`,
        MethodEnum.POST,
        null,
        { data }
    );
};

export const getTransactionTemplates = async (
    query: NextApiRequestQuery
): Promise<AxiosResponse> => {
    return await fetcher(
        `/api/account/transaction/templates`,
        MethodEnum.GET,
        query
    );
};

export const getTransactionTemplate = async (
    templateId: number
): Promise<AxiosResponse<TransactionsTemplatesApiInterface>> => {
    return await fetcher(
        `/api/account/transaction/templateDetail`,
        MethodEnum.GET,
        { templateId }
    );
};
